<h1 class="kp-modal-title">
    <slot/>
</h1>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-modal-title {
        margin: 0;
        line-height: @modal-title-line-height;
        font-weight: 500;
        font-size: 1.15em;
    }
</style>